import React, { useEffect, useMemo, useState } from 'react';
import { FaSearch } from 'react-icons/fa';
import { engineService } from '../../services/engineService';

// Tablas y columnas de un Supabase conectado, leídas de la propia base (OpenAPI de PostgREST por el motor). Para ver qué hay antes
// de armar una herramienta: nombre y tipo de cada columna, cuál es la llave, cuáles son obligatorias y a qué tabla apuntan.
export default function SchemaBrowser({ connectorId }) {
  const [state, setState] = useState('loading');
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const [q, setQ] = useState('');
  const [open, setOpen] = useState('');
  useEffect(() => {
    let live = true;
    engineService.connectorSchema(connectorId)
      .then((d) => { if (!live) return; setData(d); setOpen(d.tables[0]?.name || ''); setState('ready'); })
      .catch((e) => { if (live) { setError(e.message); setState('error'); } });
    return () => { live = false; };
  }, [connectorId]);
  const tables = useMemo(() => (data?.tables || []).filter((t) => !q.trim() || `${t.name} ${t.columns.map((c) => c.name).join(' ')}`.toLowerCase().includes(q.trim().toLowerCase())), [data, q]);
  const table = data?.tables.find((t) => t.name === open);

  if (state === 'loading') return <div aria-busy="true" className="mt-3 h-40 skeleton rounded-xl" />;
  if (state === 'error') return <p role="alert" className="mt-3 text-[13px] text-signal">{error}</p>;
  return (
    <div className="mt-3 rounded-xl ring-1 ring-line overflow-hidden">
      <div className="flex flex-wrap items-center gap-3 px-3 py-2 border-b border-line bg-raised/40">
        <div className="relative flex-1 min-w-[12rem]">
          <FaSearch aria-hidden className="absolute left-2.5 top-1/2 -translate-y-1/2 h-2.5 w-2.5 text-fg-faint" />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Buscar tabla o columna" aria-label="Buscar tabla o columna"
            className="w-full h-8 rounded-lg bg-panel pl-7 pr-2 text-[12.5px] text-fg placeholder:text-fg-faint ring-1 ring-line focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-live/60" />
        </div>
        <span className="text-[12px] text-fg-faint tabular-nums">{data.tables.length} tablas y vistas · {data.functions.length} funciones</span>
      </div>
      <div className="grid sm:grid-cols-[minmax(0,220px)_minmax(0,1fr)] max-h-[420px]">
        <ul aria-label="Tablas" className="overflow-y-auto border-b sm:border-b-0 sm:border-r border-line max-h-48 sm:max-h-[420px]">
          {tables.map((t) => (
            <li key={t.name}>
              <button type="button" onClick={() => setOpen(t.name)} aria-current={open === t.name ? 'true' : undefined}
                className={`w-full text-left px-3 py-2 font-mono text-[12.5px] focus-visible:outline-none focus-visible:bg-raised ${open === t.name ? 'bg-raised text-fg' : 'text-fg-dim hover:bg-raised/60'}`}>
                {t.name} <span className="text-fg-faint">· {t.columns.length}</span>
              </button>
            </li>
          ))}
          {!tables.length && <li className="px-3 py-3 text-[12.5px] text-fg-faint">Nada coincide.</li>}
        </ul>
        <div className="overflow-auto max-h-[420px]">
          {table ? (
            <table className="w-full text-[12.5px]">
              <caption className="sr-only">Columnas de {table.name}</caption>
              <thead className="sticky top-0 bg-panel">
                <tr className="text-left text-[11.5px] text-fg-faint"><th className="px-3 py-2 font-semibold">Columna</th><th className="px-3 py-2 font-semibold">Tipo</th><th className="px-3 py-2 font-semibold">Detalles</th></tr>
              </thead>
              <tbody>
                {table.columns.map((c) => (
                  <tr key={c.name} className="border-t border-line">
                    <td className="px-3 py-1.5 font-mono text-fg">{c.name}</td>
                    <td className="px-3 py-1.5 font-mono text-fg-dim">{c.type}</td>
                    <td className="px-3 py-1.5 text-fg-dim">{[c.pk && 'llave', c.required && !(c.hasDefault || (c.pk && /^(bigint|integer|smallint|int2|int4|int8)$/.test(c.type))) && 'obligatoria', (c.hasDefault || (c.pk && /^(bigint|integer|smallint|int2|int4|int8)$/.test(c.type))) && 'automática', c.fk && `→ ${c.fk}`, c.enum?.length && `opciones: ${c.enum.join(', ')}`].filter(Boolean).join(' · ') || '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : <p className="px-3 py-3 text-[12.5px] text-fg-faint">Elige una tabla.</p>}
        </div>
      </div>
    </div>
  );
}
